import {useModal} from 'client/common/hooks/modal';

import Component from './modal';

export {useModal};

export default Component;
